import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { WoundForm } from '../../models';

/**
 * Wound Status Form
 */
@Component({
    selector: 'app-wound-form',
    templateUrl: './wound-form.component.html',
    styleUrls: ['./wound-form.component.scss'],
})
export class WoundFormComponent {
    /**
     * Form group
     */
    @Input() formGroup: FormGroup<WoundForm>;

    /**
     * Is bed side mode
     */
    @Input() isBedSideMode: boolean;

    /**
     * Is form active / visible
     */
    @Input() isActive: boolean;

    /**
     * Max textarea rows count size
     */
    @Input() textareaMaxRows = 32;

    /**
     * Keyboard enter clicked
     */
    @Output() keyboardEnterClicked: EventEmitter<void> = new EventEmitter();
}
